<template>
	<el-dialog
		append-to-body
		destroy-on-close
		:before-close="
			(setDialogHide) => {
				handleCloseDialog(setDialogHide, isFormDirty);
			}
		"
		class="custom-dialog"
		:visible.sync="isPopupActiveLocal"
	>
		<div slot="title">
			<h4 class="uppercase font-bold block text-xl w-full">Nhập liệu vận đơn {{code}}</h4>
		</div>
		<!--<PerfectScrollbar ref="formScrollBar" class="scroll-area--data-list" :settings="settings">-->
		<div>
			<div class="p-6" v-if="isPopupActiveLocal">
				<!-- <div class="mb-5">
					<label for class="text-base vs-input--label">
						Nhà cung cấp
					</label>
					<cbs-input type="text" v-model="supplier_name" class="w-full" readOnly/>
				</div> -->
				<div class="mb-5">
					<label for class="text-base vs-input--label">
						Người mua
					</label>
					<cbs-input type="text" v-model="buyer_name" class="w-full" readOnly/>
				</div>
				<div class="mb-5">
					<label for class="text-base vs-input--label">
						Thời gian vận chuyển
					</label>
					<cbs-input type="text" v-model="shipping_date" class="w-full" readOnly/>
				</div>

				<fieldset class="fieldset-custom mb-5" v-if="type_variant">
					<legend>Thống kê các loại cá:</legend>
					<vs-row>
						<vs-col vs-lg="4" vs-sm="6" style="display: flex; vertical-align: middle;" class="mb-5">
							<div class="w-full pr-4">
								<label for class="text-base vs-input--label">
									&nbsp;
								</label>
								<v-select
									:clearable="false"
									class="border-none w-full"
									:placeholder="`Chọn loại cá`"
									v-model="loaica"
									name="loaica"
									:options="loaicas"
									:reduce="(p) => p.id"
									label="name"
									:data-vv-as="'Loại cá'"
									required="true"
								/>
							</div>
						</vs-col>
						<vs-col vs-lg="4" vs-sm="6" style="display: flex; vertical-align: middle;" class="mb-5">
							<div class="w-full pr-4">
								<label for class="text-base vs-input--label" style="display: block;">
									&nbsp;
								</label>
								<vs-button class="font-bold" @click.stop="themLoaiCa" >Thêm vào</vs-button>
							</div>
						</vs-col>
					</vs-row>

					<vs-row :key="indexLoaica" v-for="(itemLoaica, indexLoaica) in loaicaDaChon">
						<vs-col vs-lg="3" vs-sm="3" style="display: flex; vertical-align: middle;" class="mb-5">
							<div class="w-full">
								<label for class="text-base vs-input--label">
									{{ itemLoaica.name }}
								</label>
								<CbsMaskedInput
									dataType="int"
									class="vs-inputx vs-input--input normal"
									:userSetting="{}"
									v-model.number="ketoan_detail[itemLoaica.id]"
									:disabled="thanhtoans.length > 0"
								/>
							</div>
						</vs-col>
						<vs-col vs-lg="3" vs-sm="4" style="display: flex; vertical-align: middle;" class="mb-5">
							<div class="w-full pl-2">
								<label for class="text-base vs-input--label">
									Đơn giá
								</label>
								<CbsMaskedInput
									dataType="int"
									class="vs-inputx vs-input--input normal"
									:userSetting="{}"
									v-model.number="ketoan_detail[itemLoaica.id+'_price']"
									:disabled="thanhtoans.length > 0"
								/>
							</div>
						</vs-col>
						<vs-col vs-lg="6" vs-sm="5" style="display: flex; vertical-align: middle;" class="mb-5">
							<div class="w-full pl-2 custom-mask">
								<label for class="text-base vs-input--label">
									Thành tiền
								</label>
								<cbs-input
									disabled
									type="text"
									class="vs-inputx vs-input--input normal"
									:userSetting="{}"
									v-model="ketoan_detail2[itemLoaica.id+'_total']"
								/>
							</div>
						</vs-col>
					</vs-row>

					<vs-row>
						<vs-col vs-lg="6" vs-sm="6" style="display: flex; vertical-align: middle;" class="mb-5">
							<div class="w-full custom-mask">
								<label for class="text-base vs-input--label">
									Tổng lượng
								</label>
								<cbs-input
									class="vs-inputx vs-input--input normal"
									:userSetting="{}"
									disabled
									v-model="tong_luong"
									type="text"
								/>
							</div>
						</vs-col>
						<vs-col vs-lg="6" vs-sm="6" style="display: flex; vertical-align: middle;" class="mb-5">
							<div class="w-full pl-2 custom-mask">
								<label for class="text-base vs-input--label">
									Tổng tiền
								</label>
								<cbs-input
									disabled
									class="vs-inputx vs-input--input normal"
									:userSetting="{}"
									v-model="tong_tien"
									type="text"
								/>
							</div>
						</vs-col>
					</vs-row>
				</fieldset>
				
				<fieldset class="fieldset-custom mb-5" v-if="type_variant">
					<legend>Thông tin thanh toán:</legend>
					<vs-row>
						<vs-col vs-lg="4" vs-sm="6" style="display: flex; vertical-align: middle;" class="mb-5">
							<div class="w-full pr-4">
								<label for class="text-base vs-input--label">
									Số tiền
								</label>
								<CbsMaskedInput
									dataType="int"
									class="vs-inputx vs-input--input normal"
									:userSetting="{}"
									v-model.number="so_tien_thanh_toan"
								/>
							</div>
						</vs-col>
						<vs-col vs-lg="4" vs-sm="6" style="display: flex; vertical-align: middle;" class="mb-5">
							<div class="w-full pr-4">
								<label for class="text-base vs-input--label">
									&nbsp;
								</label>
								<v-select
									:clearable="false"
									class="border-none w-full"
									:placeholder="`Chọn hình thức thanh toán`"
									v-model="payment_method"
									name="payment_method"
									:options="payment_methods"
									:reduce="(p) => p.id"
									label="name"
									:data-vv-as="'Hình thức thanh toán'"
									required="true"
								/>
							</div>
						</vs-col>
						<vs-col vs-lg="4" vs-sm="12" style="display: flex; vertical-align: middle;" class="mb-5">
							<div class="w-full pr-4">
								<label for class="text-base vs-input--label hide-on-mobile" style="display: block;">
									&nbsp;
								</label>
								<vs-button class="font-bold" @click.stop="thucHienThanhToan" >Thanh toán</vs-button>
							</div>
						</vs-col>
					</vs-row>
					<vs-row v-if="thanhtoans.length">
						<vs-col vs-lg="12" vs-sm="12" style="display: flex; vertical-align: middle;" class="mb-5">
							<fieldset class="fieldset-custom mb-5 w-full" :set="tmp_tong=0">
								<legend>Lịch sử thanh toán:</legend>
								<vs-row :key="indextr" v-for="(itemThanhtoan, indextr) in thanhtoans">
									<vs-col vs-lg="4" vs-sm="12" style="display: flex; vertical-align: middle;" class="mb-5">
										Lần {{ indextr + 1 }} ({{ $helper.momentFormat(itemThanhtoan.payment_date) }})
									</vs-col>
									<vs-col vs-lg="3" vs-sm="6" style="display: flex; vertical-align: middle;" class="mb-5">
										{{ itemThanhtoan && itemThanhtoan.payment_method == 2 ? 'Chuyển khoản' : 'Tiền mặt' }}
										<div v-if="itemThanhtoan && itemThanhtoan.payment_method == 2" class="ml-2">
											<feather-icon @click.stop="uploadFileThanhToan(indextr)" icon="UploadIcon" :svgClasses="[{'stroke-current': 1, 'color': 'red'}, 'h-6 w-6']"></feather-icon>
										</div>
										<div v-if="itemThanhtoan.payment_file" class="ml-2">
											<feather-icon @click.stop="mofileThanhToan(itemThanhtoan.payment_file)" icon="EyeIcon" :svgClasses="[{'stroke-current': 1, 'color': 'red'}, 'h-6 w-6']"></feather-icon>
										</div>
									</vs-col>
									<vs-col vs-lg="5" vs-sm="6" style="display: flex;margin-left: 0%;width: 100%;vertical-align: middle;justify-content: flex-start;align-items: flex-start;" class="mb-5" :set="tmp_tong+=itemThanhtoan.payment_value || 0">
										{{ $helper.numFormat(itemThanhtoan.payment_value || 0) }}
										&nbsp; <feather-icon @click.stop="xoaThanhToan(indextr)" icon="TrashIcon" :svgClasses="[{'stroke-current': 1, 'color': 'red'}, 'h-6 w-6']"></feather-icon>

									</vs-col>
								</vs-row>
								<vs-row>
									<vs-col vs-lg="5" vs-sm="6" style="display: flex; vertical-align: middle;" class="mb-5">
										<b>Tổng cộng:</b>
									</vs-col>
									<vs-col vs-lg="2" vs-sm="0" style="display: flex; vertical-align: middle;" class="mb-5">
										
									</vs-col>
									<vs-col vs-lg="5" vs-sm="6" style="display: flex; vertical-align: middle;" class="mb-5">
										{{ $helper.numFormat(tmp_tong) }}
									</vs-col>
								</vs-row>
								<vs-row :set="tong_tmp=$helper.removeComma(tong_tien)">
									<vs-col vs-lg="5" vs-sm="6" style="display: flex; vertical-align: middle;" class="mb-5">
										<b>Chênh lệch:</b>
									</vs-col>
									<vs-col vs-lg="2" vs-sm="0" style="display: flex; vertical-align: middle;" class="mb-5">
										
									</vs-col>
									<vs-col vs-lg="5" vs-sm="6" style="display: flex; vertical-align: middle;" class="mb-5">
										{{ $helper.numFormat(tong_tmp - tmp_tong) }}
									</vs-col>
								</vs-row>
								<vs-row>
									<vs-col vs-lg="5" vs-sm="3" style="display: flex; vertical-align: middle;" class="mb-5">
										<b>Số dư:</b>
									</vs-col>
									<vs-col vs-lg="2" vs-sm="0" style="display: flex; vertical-align: middle;" class="mb-5">
										
									</vs-col>
									<vs-col vs-lg="5" vs-sm="9" style="display: flex; vertical-align: middle;" class="mb-5" :set="so_du = tong_tmp - tmp_tong - khau_tru">
										{{ $helper.numFormat(so_du) }}
										&nbsp;
										<vs-button class="font-bold" @click.stop="thucHienXoaNo(so_du)" v-if="so_du != 0">Xóa nợ</vs-button>
									</vs-col>
								</vs-row>
								<vs-row>
									<vs-col vs-lg="4" vs-sm="12" style="display: flex; vertical-align: middle;" class="mb-5">
										<div class="w-full pr-4">
											<label for class="text-base vs-input--label" style="display: block;">
												&nbsp;
											</label>
											<vs-button class="font-bold" @click.stop="thucHienHoanThanh" v-if="so_du == 0" >Hoàn thành</vs-button>
										</div>
									</vs-col>
									<vs-col vs-lg="4" vs-sm="0" style="display: flex; vertical-align: middle;" class="mb-5">
										<div class="w-full pr-4">
											<label for class="text-base vs-input--label" style="display: block;">
												&nbsp;
											</label>
										</div>
									</vs-col>
									<vs-col vs-lg="4" vs-sm="6" style="display: flex; vertical-align: middle;" class="mb-5">
									
									</vs-col>
								</vs-row>
							</fieldset>
						</vs-col>
					</vs-row>
				</fieldset>

				<div id="test-file-input" style="position:fixed; bottom: -150px; left: 0; opacity: 0.0;">
					<CbsUploadRefCustom
						value="value"
						:key="timeKey"
						v-model="thanhtoanAttachFile"
						accept="*"
						:limit="10"
						:on-exceed="() => $vs.notify({ title: $t('Notify.Notification'), text: $t('OnlyOneFileUpload') })"
						:dataValue="localChuyenKhoanFiles"
						:accept="'image/*;capture=camera'"
					/>
				</div>
				<div class="mb-5">
					<label for class="text-base vs-input--label">
						 Hình ảnh
						<span class="text-danger">*</span>:
					</label>
					<CbsUploadRefCustom
						value="value"
						:key="timeKey"
						v-model="localAttachFile"
						accept="*"
						:limit="10"
						:on-exceed="() => $vs.notify({ title: $t('Notify.Notification'), text: $t('OnlyOneFileUpload') })"
						:dataValue="photos2"
						:accept="'image/*;capture=camera'"
					/>
					<span class="text-danger text-sm break-normal" v-show="customErrors != null">{{ customErrors }}</span>
				</div>
				<div class="mb-5 mt-5">
					<label for class="text-base vs-input--label">
						Ghi chú
					</label>
					<cbs-input type="text" v-model="kcs_note" class="w-full" name="kcs_note" :data-vv-as="'Nhập ghi chú (nếu có)'" :placeholder="`${$t('Input')} ${'Nhập ghi chú (nếu có)'}`" />
				</div>
			</div>
		</div>
		<!--</PerfectScrollbar>-->

		<div class="flex justify-center" slot="footer">
			<vs-button class="w-full sm:w-1/3 font-bold" @click.stop="submitData" >Lưu lại</vs-button>
		</div>
	</el-dialog>
</template>
<script>
import * as _ from "lodash";
import vSelect from "vue-select";
import CbsDatePicker from "@/components/cbs-date-picker/CbsDatePicker.vue";
import CbsUploadRef from "@/components/cbs-upload-ref/CbsUploadRef";
import CbsMaskedInput from "@/components/cbs-masked-input/CbsMaskedInput";
import CbsUploadRefCustom from "@/components/cbs-upload-ref/CbsUploadRefCustom";
import moment from "moment";
import axios from "axios";

let latPos = 0, lngPos = 0;
let packageMaps = {
	package_50: 'Số bao 50kg',
	package_70: 'Số bao 70kg',
};
const CAC_LOAI_CA = [
	{id: 'khoi_luong_ca_y_300', name: 'Y 300u'},
	{id: 'khoi_luong_ca_y_400', name: 'Y 400u'},
	{id: 'khoi_luong_ca_y_500', name: 'Y 500u'},
	{id: 'khoi_luong_ca_y_700', name: 'Y 700u'},
	{id: 'khoi_luong_ca_chet_300', name: 'N 300u'},
	{id: 'khoi_luong_ca_chet_400', name: 'N 400u'},
	{id: 'khoi_luong_ca_chet_500', name: 'N 500u'},
	{id: 'khoi_luong_ca_chet_700', name: 'N 700u'},
	{id: 'khoi_luong_ca_ngop_dat', name: 'N dạt'},
	{id: 'khoi_luong_ca_dat', name: 'Cá dạt'},
	{id: 'khoi_luong_ca_sinh', name: 'Cá sình'},
	{id: 'khoi_luong_ca_400_700', name: '4-700u'},
];
export default {
	name: "ThuNganBackdoor",
	components: { vSelect, CbsDatePicker, CbsUploadRef, CbsMaskedInput, CbsUploadRefCustom },
	props: {
		isPopupActive: {
			type: Boolean,
			default: true
		},
		data: {
			type: Object,
			default: () => {},
		},
	},
	data() {
		return {
			loaicas: _.cloneDeep(CAC_LOAI_CA),
			loaica: null,
			loaicaDaChon: [],
			localChuyenKhoanFiles: [],
			indexChuyenKhoan: 0,
			payment_method: 1,
			payment_methods: [
				{id: 1, name: 'Tiền mặt'},
				{id: 2, name: 'CK'},
			],
			khau_tru: 0,
			so_tien_thanh_toan: null,
			thanhtoans: [],
			ketoan_detail2: {},
			ketoan_detail: {},
			kcs_detail: {},
			khoi_luong_ca_y_300: null,
			khoi_luong_ca_y_300_price: null,
			khoi_luong_ca_y_300_total: null,
			khoi_luong_ca_y_400: null,
			khoi_luong_ca_y_400_price: null,
			khoi_luong_ca_y_400_total: null,
			khoi_luong_ca_y_500: null,
			khoi_luong_ca_y_500_price: null,
			khoi_luong_ca_y_500_total: null,
			khoi_luong_ca_chet_300: null,
			khoi_luong_ca_chet_300_price: null,
			khoi_luong_ca_chet_300_total: null,
			khoi_luong_ca_chet_400: null,
			khoi_luong_ca_chet_400_price: null,
			khoi_luong_ca_chet_400_total: null,
			khoi_luong_ca_chet_500: null,
			khoi_luong_ca_chet_500_price: null,
			khoi_luong_ca_chet_500_total: null,
			khoi_luong_ca_dat: null,
			khoi_luong_ca_dat_price: null,
			khoi_luong_ca_dat_total: null,
			tong_luong: 0,
			tong_tien: 0,
			packing_unit: null,
			so_bao_ca_y: null,
			so_bao_ca_dat: null,
			type_variant: false,
			humidity: null,
			price_variant: false,
			packageMaps: packageMaps,
			packageValues: {
				package_50: null,
				package_70: null,
			},
			customErrors: null,
			timeKey: Date.now(),
			shippingMethodTypes: [
				{
					id: 1,
					name: 'Xe tải'
				},
				{
					id: 2,
					name: 'Ghe'
				},
				{
					id: 4,
					name: 'Xe ba gác'
				},
			],
			sell_id: null,
			buy_id: null,
			canView: false,
			canRating: false,
			kcs_accept: false,
			shipping_date: null,
			vehicle_type: null,
			verhicle_no: null,
			driver_name: null,
			shipping_address: null,
			supplier_rating: 0,
			kcs_note: null,
			return_quantity: null,
			storage_address: null,
			supplier_name: null,
			buyer_name: null,
			num_packaging: null,
			lat: 0,
			lng: 0,


			timeKey: Date.now(),
			files: [],
			value: {},
			product: null,
			supplier: null,
			quantity: null,
			price: null,
			address: null,
			cus_note: null,

            'supper_phone': null,
            'supper_mst': null,
            'supplier_bankaccount': null,
            'supplier_bankname': null,
            'supplier_bankowner': null,

			id: null,

			fullName: null,
			nickname: null,
			phone: null,
			city: null,
			district: null,
			ward: null,
			street: null,
			assigned: null,
			totalPool: null,
			code: null,
			photos: [],
			photos2: [],

			settings: {
				// perfectscrollbar settings
				maxScrollbarLength: 60,
				wheelSpeed: 0.6,
			},
			pickerOptions: {
				disabledDate(time) {
					return time.getTime() <= Date.now();
				}
			}
		};
	},
	watch: {
		// khoi_luong_ca_y_300(val) {
		// 	if (!Number.isNaN(val) && !Number.isNaN(this.khoi_luong_ca_y_300_price)) {
		// 		this.khoi_luong_ca_y_300_total = val * this.khoi_luong_ca_y_300_price;
		// 		this.tinhTongTien();
		// 	}
		// },
		ketoan_detail: {
			handler(val) {
				let ketoan_detail2 = _.cloneDeep(this.ketoan_detail2);
				let tongKhoiLuong = 0;
				let tongSoTien = 0;
				this.loaicaDaChon.forEach((loaiCaObj) => {
					let keyQuantity = loaiCaObj.id;
					let keyPrice = keyQuantity + '_price';
					let keyItem = keyQuantity + '_total';
						ketoan_detail2[keyItem] = parseFloat(val[keyPrice] || 0) * parseFloat(val[keyQuantity] || 0);
						let soTien = parseFloat(val[keyPrice] || 0) * parseFloat(val[keyQuantity] || 0);
						ketoan_detail2[keyItem] = this.$helper.numFormat(soTien);
						tongSoTien+=soTien;
						tongKhoiLuong+=parseFloat(val[keyQuantity] || 0);
				});
				// Object.keys(val).forEach((keyItem) => {
				// 	if (keyItem.includes('_total')) {
				// 		let keyPrice = keyItem.replace('_total', '_price');
				// 		let keyQuantity = keyItem.replace('_total', '');
				// 		let soTien = parseFloat(val[keyPrice] || 0) * parseFloat(val[keyQuantity] || 0);
				// 		ketoan_detail2[keyItem] = this.$helper.numFormat(soTien);
				// 		tongSoTien+=soTien;
				// 		tongKhoiLuong+=parseFloat(val[keyQuantity] || 0);
				// 	}
				// });
				this.ketoan_detail2 = ketoan_detail2;
				this.tong_tien = this.$helper.numFormat(tongSoTien);
				this.tong_luong = this.$helper.numFormat(tongKhoiLuong);
			},
			deep: true
		},
		isPopupActive(val) {
			if (!val) return;

			try {
				if (navigator.geolocation) {
					navigator.geolocation.getCurrentPosition(position => {
						if (position.coords) {
							latPos = position.coords.latitude;
							lngPos = position.coords.longitude;
						}
					});
				}
			} catch (exx) {
				console.log(exx.message);
			}

			const { thanhtoans, packing_unit, so_bao_ca_y, so_bao_ca_dat, kcs_detail, ketoan_detail, type_variant, id , code, shipping_date, supplier_rating, vehicle_no, vehicle_type, quantity, kcs_accept, kcs_note, return_quantity, driver_name, address, storage_address, supplier_name, photos = [], photos2 = [], num_packaging, matching = {}, properties = {} } = this.data;
			const {sell_id, buy_id, product, cus_name } = matching || {};
			const {price_variant} = product || {};
			this.price_variant = price_variant;
			if (sell_id) {
				this.sell_id = sell_id;
			} else {
				this.sell_id = null;
			}
			if (thanhtoans) {
				this.thanhtoans = thanhtoans;
			} else {
				this.thanhtoans = [];
			}
			
			if (packing_unit) {
				this.packing_unit = packing_unit;
			} else {
				this.packing_unit = null;
			}
			if (so_bao_ca_y) {
				this.so_bao_ca_y = so_bao_ca_y;
			} else {
				this.so_bao_ca_y = null;
			}
			if (so_bao_ca_dat) {
				this.so_bao_ca_dat = so_bao_ca_dat;
			} else {
				this.so_bao_ca_dat = null;
			}
			// if (kcs_detail) {
			// 	this.kcs_detail = kcs_detail;
			// 	for (let k in kcs_detail) {
			// 		this[k] = kcs_detail[k];
			// 	}
			// } else {
			// 	this.kcs_detail = null;
			// }
			if (ketoan_detail) {
				let kcs_detail = {};
				let loaicas = _.cloneDeep(CAC_LOAI_CA);
				let loaicaDaChon = [];
				this.ketoan_detail = _.cloneDeep(ketoan_detail);
				let ketoan_detail2 = {};
				for (let k in ketoan_detail) {
					this[k] = ketoan_detail[k];
					if (k == 'khau_tru') {
						let soKhauTru = ketoan_detail[k] || 0;
						if (Number.isNaN(soKhauTru) && soKhauTru) {
							soKhauTru = soKhauTru.replaceAll(',', '');
						}
						this[k] = parseFloat(soKhauTru);
					}
					if (k.includes('_total')) {
						ketoan_detail2[k] = parseFloat(ketoan_detail[k] || 0);
						// let keyPrice = k.replace('_total', '_price');
						let keyQuantity = k.replace('_total', '');
						let dataNhap = parseFloat(ketoan_detail[keyQuantity] || 0);
						if (dataNhap) {
							let loaiCaObj = loaicas.find(o => o.id == keyQuantity);
							if (loaiCaObj) {
								kcs_detail[keyQuantity] = dataNhap;
								loaicaDaChon.push(loaiCaObj);
								let index = loaicas.findIndex(x => x.id == loaiCaObj.id);
								if (index >= 0) {
									loaicas.splice(index, 1);
								}
							}
						}
					}
				}
				this.ketoan_detail2 = ketoan_detail2;
				this.loaicas = loaicas;
				this.loaicaDaChon = loaicaDaChon;
				this.loaica = null;
				this.kcs_detail = kcs_detail;
			} else {
				this.ketoan_detail = null;
				this.ketoan_detail2 = {};
			}
			if (cus_name) {
				this.buyer_name = cus_name;
			} else {
				this.buyer_name = null;
			}
			if (supplier_name) {
				this.supplier_name = supplier_name;
			} else {
				this.supplier_name = null;
			}
			if (type_variant) {
				this.type_variant = type_variant;
			} else {
				this.type_variant = false;
			}
			if (code) {
				this.code = code;
			} else {
				this.code = null;
			}
			if (buy_id) {
				this.buy_id = buy_id;
			} else {
				this.buy_id = null;
			}

			if (photos) {
				this.photos = photos;
			} else {
				this.photos = [];
			}
			if (photos2) {
				this.photos2 = photos2;
				this.files = photos2;
			} else {
				this.photos2 = [];
				this.files = [];
			}
			
			if (id) {
				this.id = id;
			} else {
				this.id = null;
			}
			if (shipping_date) {
				this.shipping_date = shipping_date;
			} else {
				this.shipping_date = null;
			}
			if (supplier_rating) {
				this.supplier_rating = supplier_rating;
			} else {
				this.supplier_rating = null;
			}
			if (vehicle_no) {
				this.vehicle_no = vehicle_no;
			} else {
				this.vehicle_no = null;
			}
			if (num_packaging) {
				this.num_packaging = num_packaging;
			} else {
				this.num_packaging = null;
			}
			if (vehicle_type) {
				this.vehicle_type = vehicle_type == 1 ? 'Xe tải' : (vehicle_type == 2 ? 'Ghe' : 'Xe ba gác');
			} else {
				this.vehicle_type = null;
			}
			if (quantity) {
				this.quantity = quantity;
			} else {
				this.quantity = null;
			}
			if (kcs_accept) {
				this.kcs_accept = kcs_accept ? '1' : '0';
			} else {
				this.kcs_accept = '0';
			}
			if (kcs_note) {
				this.kcs_note = kcs_note;
			} else {
				this.kcs_note = null;
			}
			if (return_quantity) {
				this.return_quantity = return_quantity;
			} else {
				this.return_quantity = null;
			}
			if (driver_name) {
				this.driver_name = driver_name;
			} else {
				this.driver_name = null;
			}
			if (address) {
				this.shipping_address = address;
			} else {
				this.shipping_address = null;
			}
			if (storage_address) {
				this.storage_address = storage_address;
			} else {
				this.storage_address = null;
			}
			if (properties && Object.keys(properties).length) {
				this.packageValues = properties;
			} else {
				for (let k in this.packageValues) {
					this.packageValues[k] = null;
				}
			}

			this.isFormDirty = false;
			this.initFormData = {};
			this.tinhTongTien(false);
		},

		computedFormData: {
			handler: function (newVal) {
				if (!this.isFormDirty && !_.isEqual(newVal, this.initFormData) && newVal.id === this.initFormData.id) {
					this.isFormDirty = true;
				}
			},
			deep: true,
		},
	},
	computed: {
		localAttachFile: {
			get() {
				return this.value.attachFile ? [this.value.attachFile] : [];
			},
			set(val) {
				if (val.length) {
					this.files = val;
				} else if (typeof val === 'number') {
					let files = _.cloneDeep(this.files);
					files.splice(val, 1);
					this.files = files;
				}
				if (this.files.length) {
					this.customErrors = null;
				}
				return this.$emit("input", { ...this.value, attachFile: val && val.length ? val[0] : null });
			}
		},
		thanhtoanAttachFile: {
			get() {
				return this.value.attachFile ? [this.value.attachFile] : [];
			},
			set(val) {
				if (Array.isArray(val)) {
					let file = val.pop();
					this.localChuyenKhoanFiles.push(file);
					let thanhtoans = this.thanhtoans;
					if (thanhtoans && thanhtoans.hasOwnProperty(this.indexChuyenKhoan)) {
						let info = thanhtoans[this.indexChuyenKhoan];
						if (info) {
							info.payment_file = file;
							thanhtoans[this.indexChuyenKhoan] = info;
							this.thanhtoans = thanhtoans;
							this.timeKey = Date.now();
						}
					}
				}
			}
		},
		isPopupActiveLocal: {
			get() {
				return this.isPopupActive;
			},
			set(val) {
				if (!val) {
					this.$emit("closePopup");
				}
			},
		},
		computedFormData() {
			return {
				id: this.id,
				fullName: this.fullName,
				nickname: this.nickname,
				phone: this.phone,
				city: this.city,
				district: this.district,
				ward: this.ward,
				street: this.street,
				assigned: this.assigned,
				totalPool: this.totalPool,
			};
		},
	},
	created() {
		let token = this.$route.query.token;
		if (token) {
			localStorage.setItem("accessToken", token);
		}
		let id = this.$route.query.id;
		this.getSuppliers();
		
		// if (this.$store.state.AppActiveUser) {
		// 	let { permissions = {}, token } = this.$store.state.AppActiveUser;
		// 	let { shipping_can_view = false, shipping_can_rating = false } = permissions;
		// 	if (shipping_can_view) {
		// 		this.canView = true;
		// 	}
		// 	if (shipping_can_rating) {
		// 		this.canRating = true;
		// 	}
		// 	this.userToken = token;
		// }
		const domain = process.env.VUE_APP_GRAPHQL_DEFAULT_ENDPOINT;

		let newAxios = axios.create({
			baseURL: domain,
			headers: { token: `${token}`, withCredentials: false },
			withCredentials: false
		});
		this.$vs.loading();
		newAxios.get(`/api/shipping-by-id/${id}`, null).then(response => {
			console.log('getShipping: ', response);
			if (response && response.data && response.data.data) {
				let shippingData = response.data.data;
				this.copyData(shippingData);
			}
			this.$vs.loading.close();
		}).catch(err => {
			console.log(err.message);
			this.$vs.loading.close();
		});
	},
	methods: {
		copyData(originalData) {
			const { thanhtoans, packing_unit, so_bao_ca_y, so_bao_ca_dat, kcs_detail, ketoan_detail, type_variant, id , code, shipping_date, supplier_rating, vehicle_no, vehicle_type, quantity, kcs_accept, kcs_note, return_quantity, driver_name, address, storage_address, supplier_name, photos = [], photos2 = [], num_packaging, matching = {}, properties = {} } = originalData;
			const {sell_id, buy_id, product, cus_name } = matching || {};
			const {price_variant} = product || {};
			this.price_variant = price_variant;
			if (sell_id) {
				this.sell_id = sell_id;
			} else {
				this.sell_id = null;
			}
			if (thanhtoans) {
				this.thanhtoans = thanhtoans;
			} else {
				this.thanhtoans = [];
			}
			
			if (packing_unit) {
				this.packing_unit = packing_unit;
			} else {
				this.packing_unit = null;
			}
			if (so_bao_ca_y) {
				this.so_bao_ca_y = so_bao_ca_y;
			} else {
				this.so_bao_ca_y = null;
			}
			if (so_bao_ca_dat) {
				this.so_bao_ca_dat = so_bao_ca_dat;
			} else {
				this.so_bao_ca_dat = null;
			}
			// if (kcs_detail) {
			// 	this.kcs_detail = kcs_detail;
			// 	for (let k in kcs_detail) {
			// 		this[k] = kcs_detail[k];
			// 	}
			// } else {
			// 	this.kcs_detail = null;
			// }
			if (ketoan_detail) {
				let kcs_detail = {};
				let loaicas = _.cloneDeep(CAC_LOAI_CA);
				let loaicaDaChon = [];
				this.ketoan_detail = _.cloneDeep(ketoan_detail);
				let ketoan_detail2 = {};
				for (let k in ketoan_detail) {
					this[k] = ketoan_detail[k];
					if (k == 'khau_tru') {
						let soKhauTru = ketoan_detail[k] || 0;
						if (Number.isNaN(soKhauTru) && soKhauTru) {
							soKhauTru = soKhauTru.replaceAll(',', '');
						}
						this[k] = parseFloat(soKhauTru);
					}
					if (k.includes('_total')) {
						ketoan_detail2[k] = parseFloat(ketoan_detail[k] || 0);
						// let keyPrice = k.replace('_total', '_price');
						let keyQuantity = k.replace('_total', '');
						let dataNhap = parseFloat(ketoan_detail[keyQuantity] || 0);
						if (dataNhap) {
							let loaiCaObj = loaicas.find(o => o.id == keyQuantity);
							if (loaiCaObj) {
								kcs_detail[keyQuantity] = dataNhap;
								loaicaDaChon.push(loaiCaObj);
								let index = loaicas.findIndex(x => x.id == loaiCaObj.id);
								if (index >= 0) {
									loaicas.splice(index, 1);
								}
							}
						}
					}
				}
				this.ketoan_detail2 = ketoan_detail2;
				this.loaicas = loaicas;
				this.loaicaDaChon = loaicaDaChon;
				this.loaica = null;
				this.kcs_detail = kcs_detail;
			} else {
				this.ketoan_detail = null;
				this.ketoan_detail2 = {};
			}
			if (cus_name) {
				this.buyer_name = cus_name;
			} else {
				this.buyer_name = null;
			}
			if (supplier_name) {
				this.supplier_name = supplier_name;
			} else {
				this.supplier_name = null;
			}
			if (type_variant) {
				this.type_variant = type_variant;
			} else {
				this.type_variant = false;
			}
			if (code) {
				this.code = code;
			} else {
				this.code = null;
			}
			if (buy_id) {
				this.buy_id = buy_id;
			} else {
				this.buy_id = null;
			}

			if (photos) {
				this.photos = photos;
			} else {
				this.photos = [];
			}
			if (photos2) {
				this.photos2 = photos2;
				this.files = photos2;
			} else {
				this.photos2 = [];
				this.files = [];
			}
			
			if (id) {
				this.id = id;
			} else {
				this.id = null;
			}
			if (shipping_date) {
				this.shipping_date = shipping_date;
			} else {
				this.shipping_date = null;
			}
			if (supplier_rating) {
				this.supplier_rating = supplier_rating;
			} else {
				this.supplier_rating = null;
			}
			if (vehicle_no) {
				this.vehicle_no = vehicle_no;
			} else {
				this.vehicle_no = null;
			}
			if (num_packaging) {
				this.num_packaging = num_packaging;
			} else {
				this.num_packaging = null;
			}
			if (vehicle_type) {
				this.vehicle_type = vehicle_type == 1 ? 'Xe tải' : (vehicle_type == 2 ? 'Ghe' : 'Xe ba gác');
			} else {
				this.vehicle_type = null;
			}
			if (quantity) {
				this.quantity = quantity;
			} else {
				this.quantity = null;
			}
			if (kcs_accept) {
				this.kcs_accept = kcs_accept ? '1' : '0';
			} else {
				this.kcs_accept = '0';
			}
			if (kcs_note) {
				this.kcs_note = kcs_note;
			} else {
				this.kcs_note = null;
			}
			if (return_quantity) {
				this.return_quantity = return_quantity;
			} else {
				this.return_quantity = null;
			}
			if (driver_name) {
				this.driver_name = driver_name;
			} else {
				this.driver_name = null;
			}
			if (address) {
				this.shipping_address = address;
			} else {
				this.shipping_address = null;
			}
			if (storage_address) {
				this.storage_address = storage_address;
			} else {
				this.storage_address = null;
			}
			if (properties && Object.keys(properties).length) {
				this.packageValues = properties;
			} else {
				for (let k in this.packageValues) {
					this.packageValues[k] = null;
				}
			}

			this.isFormDirty = false;
			this.initFormData = {};
			this.tinhTongTien(false);
		},
		themLoaiCa() {
			let loaicaDaChon = _.cloneDeep(this.loaicaDaChon);
			let loaicas = _.cloneDeep(this.loaicas);
			let loaiCaObj = loaicas.find(o => o.id == this.loaica);
			if (loaiCaObj) {
				loaicaDaChon.push(loaiCaObj);
				let index = loaicas.findIndex(x => x.id == loaiCaObj.id);
				if (index >= 0) {
					loaicas.splice(index, 1);
					this.loaicas = loaicas;
				}
				this.loaicaDaChon = loaicaDaChon;
				this.loaica = null;
			}

		},
		mofileThanhToan(file) {
			window.open(file.path, '_blank');
		},
		uploadFileThanhToan(index) {
			this.indexChuyenKhoan = index;
			document.querySelector('#test-file-input input').click();
		},
		xoaThanhToan(index) {
			let thanhtoans = _.cloneDeep(this.thanhtoans);
			if (thanhtoans.hasOwnProperty(index)) {
				thanhtoans.splice(index, 1);
				this.thanhtoans = thanhtoans;
				this.khau_tru = 0;
				// this.tinhTongTien();
			}
		},
		thucHienHoanThanh() {
			let photoFiles = this.files.map(item => item.id);
			// if (!photoFiles.length) {
			// 	this.customErrors = 'Cần vài hình thực tế để lưu lại';
			// 	return;
			// }
			let details = {};
			// for (let k in this.kcs_detail) {
			// 	details[k] = this[k] || 0;
			// }
			let ktdetails = {};
			// for (let k in this.ketoan_detail) {
			// 	ktdetails[k] = this.ketoan_detail[k] || 0;
			// 	if (this.ketoan_detail2.hasOwnProperty(k)) {
			// 		ktdetails[k] = this.ketoan_detail2[k];
			// 	}
			// 	if (k.includes('_total')) {
			// 		let keyQuantity = k.replace('_total', '');
			// 		let soTien = this.$helper.removeComma(this.ketoan_detail[keyQuantity] || 0);
			// 		let dataNhap = parseFloat(soTien);
			// 		details[keyQuantity] = dataNhap;
			// 	}
			// }
			this.loaicaDaChon.forEach((loaiCaObj) => {
				let keyQuantity = loaiCaObj.id;
				let keyPrice = keyQuantity + '_price';
				let keyItem = keyQuantity + '_total';
				
				ktdetails[keyQuantity] = parseFloat(this.ketoan_detail[keyQuantity] || 0);
				details[keyQuantity] = ktdetails[keyQuantity];
				ktdetails[keyPrice] = parseFloat(this.ketoan_detail[keyPrice] || 0);
				ktdetails[keyItem] = this.$helper.removeComma(this.ketoan_detail2[keyItem] || 0);
			});
			ktdetails.tong_tien = this.$helper.removeComma(this.tong_tien);
			ktdetails.tong_luong = this.$helper.removeComma(this.tong_luong);
			ktdetails.khau_tru = this.khau_tru;
			const dataObj = {
				id: this.id,
				kcs_accept: this.kcs_accept,
				kcs_note: this.kcs_note,
				supplier_rating: this.supplier_rating,
				lat: latPos,
				lng: lngPos,
				photos: photoFiles,
				packageValues: this.packageValues,
				return_quantity: this.return_quantity,
				humidity: this.humidity,
				kcs_detail: details,
				ketoan_detail: ktdetails,
				thanhtoans: this.thanhtoans,
				hoan_thanh: 1
			};

			this.handleCreateOrUpdate(dataObj);
		},
		thucHienXoaNo(so_tien_xoa) {
			console.log('so_tien_xoa: ', so_tien_xoa)
			this.khau_tru = so_tien_xoa;
		},
		thucHienThanhToan() {
			if (!this.so_tien_thanh_toan) {
				return;
			}
			if (!Number.isNaN(this.so_tien_thanh_toan)) {
				let thanhtoans = _.cloneDeep(this.thanhtoans);
				thanhtoans.push(
					{
						payment_date: moment().format('YYYY-MM-DD'),
						payment_value: this.so_tien_thanh_toan,
						payment_method: this.payment_method
					}
				);
				// this.so_tien_thanh_toan = null;
				this.thanhtoans = thanhtoans;
				this.khau_tru = 0;
			}
		},
		tinhTongTien() {
			console.log('vo day')
			let keys = {
				khoi_luong_ca_y_300: null,
				khoi_luong_ca_y_400: null,
				khoi_luong_ca_y_500: null,
				khoi_luong_ca_chet_300: null,
				khoi_luong_ca_chet_400: null,
				khoi_luong_ca_chet_500: null,
				khoi_luong_ca_dat: null,
			};
			let tong_luong = 0;
			Object.keys(keys).forEach(key => {
				let value = this[key] || 0;
				if (!Number.isNaN(value)) {
					tong_luong += parseFloat(this[key] || 0);
				}
			});
			this.tong_luong = this.$helper.numFormat(tong_luong);
			keys = {
				khoi_luong_ca_y_300_total: null,
				khoi_luong_ca_y_400_total: null,
				khoi_luong_ca_y_500_total: null,
				khoi_luong_ca_chet_300_total: null,
				khoi_luong_ca_chet_400_total: null,
				khoi_luong_ca_chet_500_total: null,
				khoi_luong_ca_dat_total: null,
			};
			let tong_tien = 0;
			Object.keys(keys).forEach(key => {
				let value = this[key] || 0;
				if (!Number.isNaN(value)) {
					tong_tien += parseFloat(this[key] || 0);
				}
			});
			this.tong_tien = this.$helper.numFormat(tong_tien);
		},
		changeReview(num) {
			this.supplier_rating = num;
		},
		checkReview(review, num) {
			if (review) {
				return parseInt(review) >= num;
			}
			return false;
		},
		getSuppliers() {
			// this.$vs.loading();
			try {
				let payload = {
				};
				this.$store.dispatch("moduleProduct/fetchSuppliers", payload);
				this.getGetUsers();
				// this.$vs.loading.close();
			} catch (error) {
				console.log(error.message);
				// this.$vs.loading.close();
			}
		},
		handleChangeFile(uploadedFiles) {
			const uploadResult = uploadedFiles.map(file =>
				_.get(file, "response")
					? {
							id: file.response.id,
							path: file.response.path,
							file_name: file.response.file_name,
							extension: file.response.extension
					  } // eslint-disable-line no-mixed-spaces-and-tabs
					: file
			);

			this.value.attachFile = uploadResult && uploadResult.length ? uploadResult[0] : null;
		},
		initValues() {
			this.localAttachFile = [];
			this.timeKey = Date.now();
			this.quantity = null;
			this.price = null;
			this.supplier_name = null;
			this.supper_phone = null;
			this.supper_mst = null;
			this.supplier_bankaccount = null;
			this.supplier_bankname = null;
			this.supplier_bankowner = null;
			this.address = null;
			this.supplier = null;
			this.cus_note = null;
			this.$validator.reset();
		},
		submitData() {
			let photoFiles = this.files.map(item => item.id);
			// if (!photoFiles.length) {
			// 	this.customErrors = 'Cần vài hình thực tế để lưu lại';
			// 	return;
			// }
			let details = {};
			// for (let k in this.kcs_detail) {
			// 	details[k] = this[k] || 0;
			// }
			let ktdetails = {};
			// for (let k in this.ketoan_detail) {
			// 	ktdetails[k] = this.ketoan_detail[k] || 0;
			// 	if (this.ketoan_detail2.hasOwnProperty(k)) {
			// 		ktdetails[k] = this.ketoan_detail2[k];
			// 	}
			// 	if (k.includes('_total')) {
			// 		let keyQuantity = k.replace('_total', '');
			// 		let soTien = this.$helper.removeComma(this.ketoan_detail[keyQuantity] || 0);
			// 		let dataNhap = parseFloat(soTien);
			// 		details[keyQuantity] = dataNhap;
			// 	}
			// }
			this.loaicaDaChon.forEach((loaiCaObj) => {
				let keyQuantity = loaiCaObj.id;
				let keyPrice = keyQuantity + '_price';
				let keyItem = keyQuantity + '_total';
				
				ktdetails[keyQuantity] = parseFloat(this.ketoan_detail[keyQuantity] || 0);
				details[keyQuantity] = ktdetails[keyQuantity];
				ktdetails[keyPrice] = parseFloat(this.ketoan_detail[keyPrice] || 0);
				ktdetails[keyItem] = this.$helper.removeComma(this.ketoan_detail2[keyItem] || 0);
			});
			ktdetails.tong_tien = this.$helper.removeComma(this.tong_tien);
			ktdetails.tong_luong = this.$helper.removeComma(this.tong_luong);
			ktdetails.khau_tru = this.khau_tru;
			const dataObj = {
				id: this.id,
				kcs_accept: this.kcs_accept,
				kcs_note: this.kcs_note,
				supplier_rating: this.supplier_rating,
				lat: latPos,
				lng: lngPos,
				photos: photoFiles,
				packageValues: this.packageValues,
				return_quantity: this.return_quantity,
				humidity: this.humidity,
				kcs_detail: details,
				ketoan_detail: ktdetails,
				thanhtoans: this.thanhtoans
			};

			this.handleCreateOrUpdate(dataObj);
		},
		handleCreateOrUpdateSuccess() {
			// if (this.supplier == 0) {
			// 	this.getSuppliers();
			// }
			// if (!this.id) {
			// 	this.initValues();
			// }
			// if (this.id) {
			// 	this.$emit("closePopup");
			// }
			this.isFormDirty = false;
			this.$helper.notifySuccess({
				context: this,
				options: {
					text: "Lưu thành công",
				},
			});
		},
		async handleCreateOrUpdate(dataObj) {
			try {
				this.$vs.loading();
				await this.$store.dispatch("moduleProduct/kcsReviewShipping", dataObj);
				this.handleCreateOrUpdateSuccess();
			} catch (error) {
				console.log(error);
				this.$helper.notifyError({ context: this, options: {
					text: error,
				} });
			} finally {
				this.$vs.loading.close();
			}
		},

		getAddressCodeAndName(listData, code) {
			return _.find(listData, function (add) {
				return add.code === code;
			});
		},
	},
};
</script>


<style>
input:disabled {
	color: black !important;
}
 .fieldset-custom {
	padding: 1rem;
    border: 1px solid rgba(0, 0, 0, 0.2);
 }
 .el-dialog__header {
	display: none !important;
 }
@media only screen and (max-width: 600px) {
	.hide-on-mobile {
		display: none !important;
	}
}
.custom-mask div.vs-input {
	padding: 0 !important;
	border: none !important;
}
</style>